import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

const SENTRY_DSN =
  import.meta.env.VITE_SENTRY_DSN ||
  "https://54c02ed295418ee9ea644cb215ddfc19@o4510433431060480.ingest.us.sentry.io/4510841147293696";

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/.*\.github\.io/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  });
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<p className="p-4 text-center text-gray-300">Something went wrong. The error has been reported.</p>}>
    <App />
  </Sentry.ErrorBoundary>
);
